module.exports = __webpack_public_path__ + "static/media/home.8d72cba2.scss";


//////////////////
// WEBPACK FOOTER
// ./src/containers/HomePage/home.scss
// module id = 147
// module chunks = 0